import { cn } from '@/lib/utils';

/**
 * The AKHub mark: an A whose feet and top are nodes and whose crossbar holds the hub they all pass through,
 * on the amber tile. Amber in both themes; the favicon (index.html) is the same drawing.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('size-8 flex-none', className)} aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#eea23a" />
      <path
        d="M9.5 23L16 9L22.5 23M12.3 17H19.7"
        fill="none"
        stroke="#2b1d0e"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g fill="#2b1d0e">
        <circle cx="9.5" cy="23" r="2.3" />
        <circle cx="16" cy="9" r="2.3" />
        <circle cx="22.5" cy="23" r="2.3" />
      </g>
      <circle cx="16" cy="17" r="3.2" fill="#fff" stroke="#2b1d0e" strokeWidth="2" />
    </svg>
  );
}

/** The product name as a wordmark: "AK" in ink, "Hub" in the brand colour. */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn('font-bold tracking-tight', className)}>
      AK<span className="text-primary">Hub</span>
    </span>
  );
}
